
  import { defineComponent } from 'vue'
  import Sidebar from '../components/Sidebar.vue'

  export default defineComponent({
    name: 'Profile',
    components: {
      Sidebar,
    },
    data() {
      return {
        menuType: 'stats',
      }
    },
    methods: {
      changeMenuType(menuType: string): void {
        this.menuType = menuType
      },
      callToggleTeacher() {
        this.$store.dispatch(
          'auth/toggleTeacher',
          !this.$store.state.auth.isTeacher
        )
      },
    },
    mounted() {
      this.$store.dispatch('auth/getStats')
    },
  })
